// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__HRzod","raised":"panel_raised__1g-9r","skinny":"panel_skinny__3f1Ad","none":"panel_none__3xP6-","panelRow":"panel_panelRow__4h644"};